// Read-only view of the collected graph. No persistence/API writes. Connectivity
// is weak (direction ignored), over ALL relation types, before UI filters.
// largestOnly selects by distinct person count, with lexical-ID ties independent
// of snapshot ordering. Hidden components stay indexed for subsequent SSE joins.
export class ComponentView {
  constructor(minimum = 5, largestOnly = false) { this.minimum = minimum; this.largestOnly = largestOnly; this.nodes = new Map(); this.edges = new Map(); }
  replace(snapshot) {
    this.nodes = new Map(snapshot.nodes.map(node => [node.id, node]));
    this.edges = new Map(snapshot.edges.map(edge => [edge.id, edge]));
  }
  apply(type, payload) {
    if (type === "NODE_UPSERT") this.nodes.set(payload.id, payload);
    else if (type === "EDGE_UPSERT") this.edges.set(payload.id, payload);
    else if (type === "EDGE_REMOVE") this.edges.delete(payload.relationId);
    else if (type === "NODE_REMOVE") {
      this.nodes.delete(payload.personId);
      for (const [id, edge] of this.edges) if (edge.sourcePersonId === payload.personId || edge.targetPersonId === payload.personId) this.edges.delete(id);
    } else return false;
    return true;
  }
  project() {
    const adjacency = new Map([...this.nodes.keys()].map(id => [id, []]));
    const validEdges = [];
    for (const edge of this.edges.values()) {
      const { sourcePersonId: source, targetPersonId: target } = edge;
      // Keep early edges in the index until BOTH endpoints arrive via SSE.
      if (source === target || !adjacency.has(source) || !adjacency.has(target)) continue;
      adjacency.get(source).push(target); adjacency.get(target).push(source);
      validEdges.push(edge);
    }
    const seen = new Set(), visible = new Set();
    let components = 0, largest = [], largestKey = null;
    for (const id of this.nodes.keys()) {
      if (seen.has(id)) continue;
      const members = [id]; seen.add(id);
      for (let i = 0; i < members.length; i++) for (const other of adjacency.get(members[i])) {
        if (!seen.has(other)) { seen.add(other); members.push(other); }
      }
      if (members.length >= this.minimum) {
        if (!this.largestOnly) { components++; for (const member of members) visible.add(member); }
        else {
          const key = members.reduce((a, b) => a < b ? a : b);
          if (members.length > largest.length || (members.length === largest.length && key < largestKey)) {
            largest = members; largestKey = key;
          }
        }
      }
    }
    if (this.largestOnly && largest.length) { components = 1; for (const id of largest) visible.add(id); }
    return { nodes: [...visible].map(id => this.nodes.get(id)),
      edges: validEdges.filter(edge => visible.has(edge.sourcePersonId)), adjacency, components };
  }
}
